import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@hero/web-lib';

export interface MaintenanceScreenProps {
  icon?: ComponentType<{ className?: string }>;
  title?: string;
  message?: string;
  className?: string;
}

export function MaintenanceScreen({
  icon: Icon,
  title,
  message,
  className,
}: MaintenanceScreenProps) {
  const { t } = useTranslation(['c-main']);

  return (
    <div className={cn('flex flex-1 items-center justify-center p-8', className)}>
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        {Icon && (
          <div className="rounded-full bg-muted p-6">
            <Icon className="h-12 w-12 text-muted-foreground" />
          </div>
        )}
        <span className="text-xs font-medium px-3 py-1 rounded-full bg-amber-100 text-amber-700">
          {t('c-main:feature_screen.maintenance_badge')}
        </span>
        <h2 className="text-2xl font-semibold tracking-tight">
          {title ?? t('c-main:feature_screen.maintenance_title')}
        </h2>
        <p className="text-muted-foreground text-base">
          {message ?? t('c-main:feature_screen.maintenance_message')}
        </p>
      </div>
    </div>
  );
}
